export const isValidEmail = email => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isValidPassword = password => {
  // 1 capital letter, 1 special character, 1 number, 10 characters
  const passwordRegex =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{10,}$/;
  return passwordRegex.test(password);
};

export const getPasswordErrorMessage = () => {
  return 'A senha deve ter no mínimo 10 caracteres, incluindo pelo menos uma letra maiúscula, um número e um caractere especial.';
};
